import { createSlice } from "@reduxjs/toolkit";

export const chatSlice = createSlice({
  name: "chats",
  initialState: {
    isConnected: false,
    channelsUnreadMsgs: [],
    chatChannels: [],
    hasUnreadMsgs: false,
    navigateToChannel: false,
    selectedChannelId: -1,
  },
  reducers: {
    setChannelsUnreadMsgs: (state, action) => {
      state.channelsUnreadMsgs = [...action.payload];
    },
    setChatChannels: (state, action) => {
      if (action.payload) {
        state.chatChannels = [...action.payload];
      }
    },
    resetChatStates: (state, action) => {
      state.showChatModal = false;
      state.selectedChatMemberData = null;
      state.isConnected = false;
      state.channelsUnreadMsgs = [];
      state.chatChannels = [];
      state.navigateToChannel = false;
    },
    setChannelUnreadMsgsStatus: (state, action) => {
      state.hasUnreadMsgs = action.payload;
    },
    setNavigateToChannel: (state, action) => {
      state.navigateToChannel = action.payload;
    },
    setSelectedChannelId: (state, action) => {
      state.selectedChannelId = action.payload;
    },
  },
});

export const {
  setChannelsUnreadMsgs,
  setChatChannels,
  resetChatStates,
  setChannelUnreadMsgsStatus,
  setNavigateToChannel,
  setSelectedChannelId,
} = chatSlice.actions;
export default chatSlice.reducer;
